import { CSSObject, BoxProps } from '@chakra-ui/react';

export const DeductionsText: CSSObject = {
  color: 'white',
  fontSize: '2xs',
  fontWeight: 'semibold',
};

export const FooterMoreOpenText: CSSObject = {
  color: 'beta.500',
  '&': {
    px: '0',
  },
  fontSize: 'xs',
  '+ div[class*="myBetsCard-ContentRow"]': {
    position: 'relative',
    borderTop: '1px rgba(0, 0, 0, 0.25) dashed',
    '&::before': {
      position: 'absolute',
      content: '""',
      width: '100%',
      height: '0',
      top: '0',
      left: '0',
      borderBottom: '1px rgba(255, 255, 255, 0.05) solid',
    },
  },
};
export const BoxMoreText: CSSObject = {
  w: '8',
};
export const DividerMulti: CSSObject = {
  position: 'relative',
  borderStyle: 'dashed',
  borderColor: 'rgba(0, 0, 0, 0.25)',
  width: 'unset',
  '&::before': {
    position: 'absolute',
    content: '""',
    width: '100%',
    height: '100%',
    top: '1px',
    left: '0',
    borderBottom: '1px rgba(255, 255, 255, 0.05) dashed',
  },
};
export const footerWrapperExpanded: BoxProps = {
  sx: {
    '& > div': {
      color: 'white',
    },
  },
};

export const toteMultiGrid: CSSObject = {
  gridTemplateColumns: 'repeat(2, 1fr)',
  gap: '6',
  display: 'grid',
};

export const toteMultiGridText: CSSObject = {
  fontSize: 'xs',
  w: 'full',
  color: 'white',
  mb: '2',
  '&.raceNumber': {
    borderBottom: '1px dashed',
    borderColor: '#00000040',
    boxShadow: '0px 1px 0px 0px #FFFFFF1A',
    fontWeight: 'bold',
  },
};
